import React, {useState} from "react";
import {GenerateApiKeyModal} from "../../../Modals/GenerateApiKeyModal";
import {Glyphicon} from "../../GlyphIcon";

/**
 * Add button rendered by MutableList in edit mode.
 * Opens the GenerateApiKeyModal; on success calls onAdd(newKey) to add the key to local list state.
 */
export const AddUserAPIKeyButton = (props) => {

    const {
        show = true,
        onAdd = () => {},
    } = props;

    if(!show) { return null; }

    const [showModal, setShowModal] = useState(false);

    return <>
        <GenerateApiKeyModal
            show={showModal}
            onHide={() => setShowModal(false)}
            onGenerated={(newKey) => onAdd(newKey)}
        />
        <div className="float-right add-table pop-add">
            <a className="pndlm-remove-control" onClick={() => setShowModal(true)}>
                <Glyphicon glyph="plus-sign"/>
            </a>
        </div>
    </>;
}